// removed by extract-text-webpack-plugin
module.exports = {"button":"_3Rrfw","message":"_3Pw4V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorMessage.css
// module id = 801
// module chunks = 0